export const nativeAdsServer = {
    baseURL: 'https://native-recommendations-api.steady.darvis.dev',
    uploadBucket: "native-recommendations-assets.steady.darvis.dev",
    uploadKey: "images",
    bucketURL: "https://native-recommendations-assets.steady.darvis.dev",
}
